import Icon from '../components/Icon.vue'

Icon.register({"burn":{"width":384,"height":512,"paths":[{"d":"M192 0C79.7 101.3 0 220.9 0 300.5 0 425 79 512 192 512S384 425 384 300.5C384 220.6 303.8 100.9 192 0zM192 448C135.5 448 96 409 96 353.2 96 339.7 100.6 291.7 192 192 283.4 291.7 288 339.7 288 353.2 288 409 248.5 448 192 448z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/burn.js
// module id = null
// module chunks = 